import { type HistoricalEventResponse } from '@solinkcorp/api-types';
import { useUserSession } from '@solinkcorp/authentication';
import { useStaleSWRConfig } from '@solinkcorp/utils/hooks';
import useSWR from 'swr';
import { useSDMClient } from '../contexts/CallhomeClientContext';

const HISTORICAL_EVENTS_CACHE_KEY = 'sdm-historical-events';

const useServiceDisplayHistoricalEvents = (
  start: number,
  end: number,
  deviceUrl: string,
): {
  data: HistoricalEventResponse[] | undefined;
  error: any;
  isLoading: boolean;
} => {
  const { accessToken } = useUserSession();
  const sdmClient = useSDMClient();
  const fetcher = async () => {
    if (!deviceUrl) {
      throw new Error('Missing device URL');
    }
    return await sdmClient.getHistoricalEvents(deviceUrl, accessToken, start, end);
  };
  const key = [HISTORICAL_EVENTS_CACHE_KEY, deviceUrl, start, end];
  const config = useStaleSWRConfig(key);

  const { data, error, isLoading } = useSWR(deviceUrl ? key : null, fetcher, config);

  return { data, error, isLoading };
};

export default useServiceDisplayHistoricalEvents;
